import api from './api';
import { Lead, LeadPayload, LeadStatus } from '../types';

const BASE = '/leads';

const leadsService = {
  list: async (): Promise<Lead[]> => {
    const res = await api.get(BASE);
    return res.data ?? [];
  },

  get: async (id: number): Promise<Lead> => {
    const res = await api.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (payload: LeadPayload): Promise<Lead> => {
    const res = await api.post(BASE, payload);
    return res.data;
  },

  update: async (id: number, payload: Partial<LeadPayload>): Promise<Lead> => {
    const res = await api.put(`${BASE}/${id}`, payload);
    return res.data;
  },

  updateStatus: async (id: number, status: LeadStatus): Promise<Lead> => {
    const res = await api.patch(`${BASE}/${id}/status`, { status });
    return res.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`${BASE}/${id}`);
  },
};

export default leadsService;
